import { useCallback } from 'react';

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from '@/analytics';
import { ActionKey, ActionSubjectKey, ActionSubjectIdKey } from '@/analytics/constants';

import { CustomerDomainJiraBoardEmbedType } from '../jira-embedded-board-section/types';

export const useMigrationsManagementUIAnalytics = () => {
	const { sourceKey, identityAttrs } = useFastshiftAnalyticsData(true);
	const { fireUIEvent } = useFireAnalyticsEvents(identityAttrs);

	// UI event callbacks
	const sendEmbedViewToggleUIEvent = useCallback(
		(selectedEmbedType: CustomerDomainJiraBoardEmbedType) => {
			fireUIEvent({
				action: ActionKey.CLICKED,
				actionSubject: ActionSubjectKey.BUTTON,
				actionSubjectId: ActionSubjectIdKey.EMBED_VIEW_TYPE_TOGGLE_BUTTON,
				source: sourceKey,
				attributes: {
					selectedEmbedType,
				},
			});
		},
		[fireUIEvent, sourceKey],
	);

	const sendBoardSelectionUIEvent = useCallback(
		(selectedProjectKey: string, selectedBoardId: string) => {
			fireUIEvent({
				action: ActionKey.CLICKED,
				actionSubject: ActionSubjectKey.BUTTON,
				actionSubjectId: ActionSubjectIdKey.SELECT_BOARD_DROPDOWN_ITEM,
				source: sourceKey,
				attributes: {
					selectedProjectKey,
					selectedBoardId,
				},
			});
		},
		[fireUIEvent, sourceKey],
	);

	const sendJiraEmbedLinkClickUIEvent = useCallback(
		(engagementUrl: string, selectedEmbedType: CustomerDomainJiraBoardEmbedType) => {
			fireUIEvent({
				action: ActionKey.CLICKED,
				actionSubject: ActionSubjectKey.LINK,
				actionSubjectId: ActionSubjectIdKey.JIRA_EMBED_LINK,
				source: sourceKey,
				attributes: {
					engagementUrl,
					selectedEmbedType,
				},
			});
		},
		[fireUIEvent, sourceKey],
	);

	return {
		sendEmbedViewToggleUIEvent,
		sendBoardSelectionUIEvent,
		sendJiraEmbedLinkClickUIEvent,
	};
};
